import { useState, useCallback } from 'react';

const useJSEncrypt = () => {
  const publicKey = `-----BEGIN PUBLIC KEY-----
  MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtL0wSlwtoCLJt1/TpZ5h
  NTrCB3x8cum+4h8GSCJj4lATFg03cRP+HamlTfjuOnCqKxs6pMdtsGewdWJeuR07
  10fbJ69paK4ecNWXC9QO1tbpv8C5ooIJVHgULM4wgBzDUA/mUReKhdIDlOnVbDvW
  ofOg055s2u8ytLTFbXTajk3j+Pt1wc5BGOXvzYNlkivYL+1Ezl5uSx58xUULoSmq
  XJDcKHnVFFdfBsjoaB1FeXVBz/PJKDXBHCpWX9rwyCM1JBL5400EqbwyUbgATLH+
  ag/9zH6pVYmey730K/9r3FrplwPs9PFTKx6UFM7LJKdtjtLG/pgEA05gYw3vowT5
  rQIDAQAB
-----END PUBLIC KEY-----`;
  // const [privateKey, setPrivateKey] = useState('');

  // 加密方法
  const encryptText = async (plainText: string) => {
    // 动态引入，不然会报 window is not defined
    const { JSEncrypt } = await import('jsencrypt')
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(plainText);
  };

  // // 解密方法
  // const decryptText = useCallback((encryptedText: string) => {
  //   if (!privateKey) {
  //     throw new Error('Private key is not set');
  //   }
  //   const decrypt = new JSEncrypt();
  //   decrypt.setPrivateKey(privateKey);
  //   return decrypt.decrypt(encryptedText);
  // }, [privateKey]);

  return {
    encryptText,
    // decryptText,
  };
};

export default useJSEncrypt;
